import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

import { type DropdownListItem, DropDownListItemStatus } from '../../Dropdown/types';

export const StyledChip = styled(Chip)<{ status?: DropdownListItem['status'] }>(({ status }) => {
  let errorStyles = {};
  if (status === DropDownListItemStatus.ERROR) {
    errorStyles = {
      border: '1px solid #F14C2E',
      backgroundColor: '#fff !important',
      color: '#F14C2E',
      '& .MuiChip-deleteIcon': {
        color: '#F14C2E',
      },
    };
  }

  let warningStyles = {};
  if (status === DropDownListItemStatus.WARNING) {
    warningStyles = {
      border: '1px solid #f6c44a',
      backgroundColor: '#fff !important',
      color: '#f6c44a',
      '& .MuiChip-deleteIcon': {
        color: '#f6c44a',
      },
    };
  }

  return {
    height: 'auto !important',
    padding: '2px 0 !important',
    ...errorStyles,
    ...warningStyles,
  };
});
